<template>
  <div
    class="finance-event-cell"
    :class="{
      'finance-event-cell-red': cellValue < 0,
      'finance-event-cell-green': cellValue > 0,
      'finance-event-cell-black': cellValue === 0,
    }"
  >
    {{ numberWithSpaces(cellValue) }}
  </div>
</template>

<script>
export default {
  name: "finance-event-cell",
  props: ["cellValue"],
  methods: {
    numberWithSpaces(x) {
      if (!x) {
        return "";
      }
      if (x > 0) {
        return `+ ${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      if (x < 0) {
        return `− ${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.finance-event-cell {
  line-height: 13px;
  font-size: 13px;
  padding: 10px !important;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;

  &-green {
    color: #12c971;
  }

  &-red {
    color: #ff238d;
  }

  &-black {
    color: #000000;
  }
}
</style>
